export default "__VITE_ASSET__pnOi74MO__"